import { FatalError } from '@rehaje/errors'

import type { Locales } from '@rehaje/errors'

export class FatalVisitorExistedError extends FatalError {
  static override locales: Locales = {
    'en-US': 'Register name %s of %s class visitor already exists',
    'zh-CN': '注册名为 %s 的 %s 类访问器已存在',
    'zh-HK': '註冊名為 %s 的 %s 類訪問器已存在'
  }

  override name = 'FatalVisitorExistedError' as const

  constructor(visitorName: string, existedName: string) {
    super(visitorName, existedName)
  }
}
